export default __webpack_public_path__ + "static/floorplan-2d-d1b9efbc297dd9451de92ea83e46de95.png";